import * as AF from "@/components/form-items/AbstractForm";
import { SupportedLocale } from "@/i18n";
import { useTranslation } from "react-i18next";

export const SectionForm = ({ lang }: { lang: SupportedLocale }) => {
  const { t } = useTranslation();
  return (
    <AF.Col>
      <AF.Text
        name={`content.${lang}.title`}
        label={t("cms.section.form.title")}
      />
      <AF.RichText
        name={`content.${lang}.content`}
        label={t("cms.section.form.content")}
      />
    </AF.Col>
  );
};

export const ImportImageForm = ({ lang }: { lang: SupportedLocale }) => {
  const { t } = useTranslation();
  return (
    <AF.RichText
      name={`caption.${lang}.content`}
      label={t("cms.selection.section.form.importImage.caption")}
    />
  );
};
